import { IDocument } from '@/interfaces/user.model';
import { renderDocumentPreview } from '@/utility/CommonFunctions';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
interface IViewDocumentModalProps {
  isOpen: boolean;
  toggle: () => void;
  selectedDocument?: Partial<IDocument> | null;
  renderDocument?: () => void;
}
const ViewDocumentModal = ({
  isOpen,
  toggle,
  selectedDocument,
  renderDocument,
}: IViewDocumentModalProps) => {
  const handleRenderContent = () => {
    if (renderDocument && typeof renderDocument === 'function') {
      const content = renderDocument();
      return content ?? <p>No document to preview.</p>;
    }

    if (selectedDocument) {
      return renderDocumentPreview(selectedDocument);
    }

    return <p>No document to preview.</p>;
  };

  return (
    <Modal className="modal-xl" isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}> Document Preview</ModalHeader>

      <ModalBody className="text-center p-4">{handleRenderContent()}</ModalBody>
    </Modal>
  );
};
export default ViewDocumentModal;
